import detectPassiveEvents from 'detect-passive-events';

export default () => detectPassiveEvents.hasSupport;

const DEFAULT_PASSIVE_HANDLER_OPTIONS = { passive: true };

export const getPassiveHandlerDefaultOptions = () => {
  if (detectPassiveEvents.hasSupport) {
    return DEFAULT_PASSIVE_HANDLER_OPTIONS;
  }
  return false;
};

const NON_PASSIVE_HANDLER_OPTIONS = { passive: false };

export const getNonPassiveHandlerOptions = () => {
  if (detectPassiveEvents.hasSupport) {
    return NON_PASSIVE_HANDLER_OPTIONS;
  }
  return false;
};
